import { composeEffects } from '../../module';

import { GoogleAnalyticsWrapper } from './googleAnalyticsWrapper';

export const GoogleAnalyticsEffects = composeEffects('google-analytics', ({ effect }) => ({
  track: effect(async (e: { eventName: string; props?: object }) =>
    Promise.resolve(GoogleAnalyticsWrapper.track(e.eventName, e.props))
  )
}));
